import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbUpdate: PageLink[] = [
  {
    title: 'Promotores',
    path: '/partnerships/promoters',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
